export default __webpack_public_path__ + "static/media/Composite Bow of the Blood Drinker.ed625054.jpg";